<div class="card">
    <p-chart type="bar" [data]="chartData" [options]="chartOptions" />
</div>